import formatPhone from '@/utils/formatPhone';

export default {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$getUserName = function $getUserName(user) {
      const contacts = this.$store.getters.userContactBook;
      let contact = null;

      if (contacts) {
        contact = contacts.find((item) => item.uid === user.uid);
      }

      if (contact) return contact.contact_name || contact.full_name || formatPhone(contact.phone);
      return user.contact_name || user.full_name || formatPhone(user.phone);
    };
  },
};
